module.exports = __webpack_public_path__ + "img/paymentCorrelation2.e616f8f9.png";